// extracted by mini-css-extract-plugin
export var content = "removeFromKitModal-module--content--ee0d3";